import { DateTimeService } from "../../services/date-time-service"
import { Status } from "../../types/common"
import { EventType } from "../utils"

type TranslationFn = (key: string) => string

type CreateTooltipTemplateArgs = {
  dateTimeService: DateTimeService
  taskTranslations: TranslationFn
  projectTranslations: TranslationFn
}

export const createTooltipTemplate = ({
  dateTimeService,
  taskTranslations,
  projectTranslations,
}: CreateTooltipTemplateArgs) => {
  return function tooltipTemplate(start: Date, end: Date, event: EventType) {
    const isMultipleDays = start.getDate() !== end.getDate()
    const startHours = start.getHours() < 10 ? `0${start.getHours()}` : `${start.getHours()}`
    const startMinutes = start.getMinutes() < 10 ? `0${start.getMinutes()}` : `${start.getMinutes()}`
    const startTime = `${startHours}:${startMinutes}`
    const startTimeToShow = isMultipleDays ? `${dateTimeService.format(start)} ${startTime}` : startTime

    const endHours = end.getHours() < 10 ? `0${end.getHours()}` : `${end.getHours()}`
    const endMinutes = end.getMinutes() < 10 ? `0${end.getMinutes()}` : `${end.getMinutes()}`
    const endTime = `${endHours}:${endMinutes}`
    const endTimeToShow = isMultipleDays ? `${dateTimeService.format(end)} ${endTime}` : endTime
    const participants = event.participants.join(", ")
    const text = event.details || event.text
    const status =
      event.status === Status.COMPLETED
        ? taskTranslations("taskStatusMenu.completed")
        : event.status === Status.IN_PROGRESS
        ? taskTranslations("taskStatusMenu.inProgress")
        : event.status === Status.REJECTED
        ? taskTranslations("taskStatusMenu.rejected")
        : taskTranslations("taskStatusMenu.notStarted")
    return `
        <span class="dhx_calendar_caption dhx_tooltip_title">${text}</span><br>
        <span class="dhx_calendar_caption">${startTimeToShow} - ${endTimeToShow}<span><br>
        <span class="dhx_calendar_caption">${participants}</span>
       ${
         event.type === "task"
           ? `<span class="dhx_calendar_caption">${projectTranslations(
               "projectDetails.statusWidgetLabel"
             )}: ${status}</span>`
           : ""
       }`
  }
}
